"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ENTER_PARENTAL_PIN_QUERY = "\n    mutation EnterParentalPin($enteredPin: String!) {\n      enterParentalPin(enteredPin: $enteredPin)\n    }\n";
exports.default = ENTER_PARENTAL_PIN_QUERY;
//# sourceMappingURL=enterParentalPin.js.map